module.exports = __webpack_public_path__ + "img/bg7.2be2ff95.jpg";